import { addHours } from 'date-fns';

import { SearchRequest } from '@/components/search/types';
import { managedPageQueryMeta, throwIfResponseNotOk } from '@/queries/queryErrorHandling';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';
import { postRequestInit } from '@/queries/utils';
import { WerklijnenInline } from '@/types/werklijnenInline';
import { QueryFunction, useQuery } from '@tanstack/react-query';

import { Reserve } from '../types';
import { derriveReserveFromWerklijn } from '../utils/reserve';

const getReserveQuery = (): SearchRequest => {
  const date = new Date(addHours(new Date(), 4)).toISOString();
  const utc = `${date.substring(0, date.lastIndexOf('.'))}Z`;
  return { criteria: [{ veld: 'reserve', van: utc }] } as unknown as SearchRequest;
};

const useGetReserves = (enabled = true) => {
  const { fetchWithAuth } = useFetchWithAuth();

  const fetcher: QueryFunction<Reserve[]> = async () => {
    const response = await fetchWithAuth('/werklijnen/zoek', postRequestInit(getReserveQuery()));
    throwIfResponseNotOk(response, `Ophalen van reserves is mislukt (${response.status}).`);
    const responseData: WerklijnenInline = await response.json();
    if (!responseData || !('werklijnen' in responseData) || !Array.isArray(responseData?.werklijnen)) return [];
    return responseData.werklijnen.map(derriveReserveFromWerklijn);
  };

  return useQuery({
    queryKey: ['reservesVanafNu', 'v1'],
    queryFn: fetcher,
    refetchInterval: 10_000,
    meta: managedPageQueryMeta,
    enabled,
  });
};
export default useGetReserves;
